// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// es6
// require('es6-promise').polyfill()
import "babel-polyfill"

// import Mint from 'mint-ui'
// import { MessageBox } from 'mint-ui'
import 'mint-ui/lib/style.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 移动端vant
import 'vant/lib/index.css'

// 引入公共common.css
import '../static/css/common.css'
// 引入iconfont.css
import '../static/css/iconfont.css'
import './assets/iconfont/iconfont.js'

import Vue from 'vue'
import App from './App'
import router from './router'
//vuex
import store from './store'
// es6
// require('es6-promise').polyfill()

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

//引入打印
import Print from 'vue-print-nb'
Vue.use(Print);

//引入vue-awesome-swiper轮播插件
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

// 控制台调试可加
// import VConsole from "vconsole"
// var vConsole = new VConsole()

// 引入video.js

import Videojs from 'video.js'

import 'video.js/dist/video-js.css'

//引入iframe
import VueFriendlyIframe from 'vue-friendly-iframe';


Vue.prototype.$video = Videojs
Vue.use(VueFriendlyIframe);

Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store, //使用store
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js